// @noflow
import Intercom from '@intercom/messenger-js-sdk'
import React, { useCallback } from 'react'

import useWebviewHandler from '@/hooks/useWebviewHandler'

import STYLES from './dixamessengerwebview.module.sass'

const DixaMessengerWebviewPage = (): JSX.Element => {
  const webviewHandler = useWebviewHandler()
  const userData = document.getElementById('user-data')
  if (!userData) {
    throw new Error('Could not load user data')
  }
  const {
    dataset: {
      shouldSeeIntercom,
      trackingId,
      intercomAppId,
      intercomUserHash,
      name,
      email,
      createdAt
    }
  } = userData as HTMLElement
  const usingIntercom = shouldSeeIntercom === 'true'

  const onWidgetOpenChanged = useCallback(
    (open: boolean) => {
      if (!open) {
        webviewHandler.postMessage('ON-CLOSE')
      }
    },
    [webviewHandler]
  )

  const setUpDixa = useCallback(() => {
    const interval = setInterval((): void => {
      const dixaWidget = document.getElementsByClassName(
        'dixa-messenger-wrapper'
      )[0] as HTMLElement
      const dixaWidget2 = document.getElementsByClassName(
        'dixa-messenger-wrapper'
      )[1] as HTMLElement
      if (window._dixa_ && dixaWidget) {
        dixaWidget2.style.height = '92%'
        window._dixa_.invoke('setWidgetOpen', true)
        window._dixa_.addListener('on-widget-open-changed', onWidgetOpenChanged)
        clearInterval(interval)
      }
    }, 2000)
  }, [onWidgetOpenChanged])

  const setUpIntercom = useCallback(() => {
    if (!intercomAppId) {
      throw new Error('Intercom app id is missing')
    }
    if (!intercomUserHash) {
      throw new Error('Intercom user hash is missing')
    }

    Intercom({
      app_id: intercomAppId as string,
      user_id: trackingId as string,
      name,
      email,
      created_at: parseInt(`${createdAt}`),
      user_hash: intercomUserHash
    })

    const interval = setInterval((): void => {
      const intercomButton = document.getElementsByClassName(
        'intercom-lightweight-app-launcher'
      )[0] as HTMLElement
      if (intercomButton) {
        intercomButton.style.display = 'none'
        intercomButton.click()
        clearInterval(interval)
      }
      const dixaWidget = document.getElementsByClassName(
        'dixa-messenger-wrapper'
      )[0] as HTMLElement

      if (dixaWidget) {
        dixaWidget.remove()
      }
    }, 300)
  }, [createdAt, email, intercomAppId, intercomUserHash, name, trackingId])

  React.useEffect((): void => {
    webviewHandler.pageLoaded()
    if (webviewHandler.isWebview) {
      if (usingIntercom) {
        setUpIntercom()
      } else {
        setUpDixa()
      }
    } else {
      window.location.href = '/contact'
    }
  }, [
    onWidgetOpenChanged,
    setUpDixa,
    setUpIntercom,
    usingIntercom,
    webviewHandler,
    webviewHandler.isWebview
  ])
  return (
    <div
      className={`${STYLES.container} ${
        shouldSeeIntercom ? STYLES.intercom : ''
      }`}
    />
  )
}

export default DixaMessengerWebviewPage
